import PlayFilledIcon from "resources/play-filled.svg";

import styles from "./BigPlayButton.module.scss";

export interface BigPlayButtonProps {
  onClick?: () => void;
}

export const BigPlayButton = ({ onClick }: BigPlayButtonProps) => (
  <button className={styles.play} onClick={onClick}>
    <PlayFilledIcon />
  </button>
);

export default BigPlayButton;
